import React, { PureComponent } from 'react'
import * as R from 'ramda'
import ReportPage from './ReportPage'
import ReportStat from './ReportStat'
import DeviceBrowser from './DeviceBrowser'
import XTabs from './XTabs'
import ReportHeader from './ReportHeader'
import EditAnswersModal from './EditAnswersModal'
import AiAssistant from './AiAssistant'

class RightPanel extends PureComponent {
    getPagesElements = () => {
        const {
            store,
            reportFilter,
            reportData,
            locale,
            showDebug,
            updated,
            reportStore,
            dataUpdated,
        } = this.props

        return reportStore.reportPages.map((page, i) => (
            <ReportPage
                page={page}
                reportStore={reportStore}
                store={store}
                reportFilter={reportFilter}
                showDebug={showDebug}
                reportData={reportData}
                locale={locale}
                updated={updated}
                dataUpdated={dataUpdated}
                index={i}
            />
        ))
    }

    scrollTo = (e) => {
        try {
            const pageId = e.target.getAttribute('pageId')
            document.getElementsByClassName(`toggle_${pageId}`)[0].scrollIntoView()
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        const {
            loading,
            store,
            reportStore,
            reportFilter,
        } = this.props
        const { survey } = store
        const showNonMaxbi = R.pathOr(undefined, ['metadata', 'taxonomy', 'surveyType'], survey) !== 'EM'
        const showAiAssistant = process.env.SHOW_AI_ASSISTANT
            && R.pathOr(false, ['userData', 'flags', 'isAiSummaryEnabled'], store)
            && R.pathOr(false, ['metadata', 'isSurveyAiSummaryEnabled'], survey)
            && showNonMaxbi
        return (
            <div id="pane2">
                {!loading
                    && (
                        <div id="report">
                            <div
                                className="main"
                                style={{ width: showAiAssistant ? 'calc(100% - 64px)' : '100%' }}
                            >
                                {process.env.USE_NEW_HEADER_UI
                                    ? null
                                    : <ReportHeader store={store} reportStore={reportStore} />}
                                {showNonMaxbi && (
                                    <ReportStat
                                        reportStore={reportStore}
                                        store={store}
                                        data={reportStore.reportData.stats}
                                        loading={loading}
                                        scrollTo={this.scrollTo}
                                    />
                                )}
                                {this.getPagesElements()}
                                {showNonMaxbi && (
                                    <DeviceBrowser
                                        store={store}
                                        reportStore={reportStore}
                                        deviceData={reportStore.reportData.devicesData}
                                        browserData={reportStore.reportData.browserData}
                                        loading={loading}
                                    />
                                )}
                                <XTabs
                                    reportStore={reportStore}
                                    store={store}
                                    reportFilter={reportFilter}
                                />
                                <EditAnswersModal
                                    reportStore={reportStore}
                                    toggleEditAnswers={() => { reportStore.editAnswersModalIsOpen = false }}
                                    editAnswersOpen={reportStore.editAnswersModalIsOpen}
                                    surveyURL={reportStore.editAnswersURL}
                                />
                            </div>
                            {showAiAssistant && (
                                <div className="right-toolbar">
                                    <AiAssistant reportStore={reportStore} />
                                </div>
                            )}
                        </div>
                    )}
            </div>
        )
    }
}

export default RightPanel
